// Import any necessary dependencies
import { put, call, takeLatest, all, select } from 'redux-saga/effects';
import {
    FETCH_SALES_REP_RECORDS,
    fetchSalesRepRecordsSuccess,
    fetchSalesRepRecordsFailure,
    updateAnyState,
    UPDATE_SUMMARY_VIEW
} from '../actions/fetchSalesRepRecordsActions';
import {BASE_BACKEND_URL}  from '../constant';
import { toast } from 'react-toastify';

const fetchSalesRepRecordsAPI = async () => {
    const response = await fetch(
        `${BASE_BACKEND_URL}/sales_rep`
    );

    if (!response.ok) {
        toast.error('Error fetching file details', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light'
        });
        throw new Error('Error fetching file details');
    }

    const data = await response.json();
    return data;
};

function* fetchSalesRepRecordsWorker(action) {
    try {
        const sales_rep = yield select((state) => state.salesrep.sales_rep);
        if (sales_rep.length === 0) {
            yield put(updateAnyState({'loading':true}));
            const data = yield call(fetchSalesRepRecordsAPI);
            yield put(fetchSalesRepRecordsSuccess(data));
        } else { 
            yield put(updateAnyState({loading:false}));

        }
    } catch (error) {
        yield put(fetchSalesRepRecordsFailure(error.message));
    }
}

function* fetchSalesRepRecordsWatcher() {
    yield takeLatest(FETCH_SALES_REP_RECORDS, fetchSalesRepRecordsWorker);
}
export default fetchSalesRepRecordsWatcher;